    import { TimestampFormatPipe } from './../commons/timestampFormatPipe';
    import { MatSnackBar } from '@angular/material/snack-bar';
    import { Router } from '@angular/router';
    import { DateAdapter } from '@angular/material/core';
    import { NavigatorService } from './../services/navigator.service';
    import { Component, OnInit, OnDestroy } from '@angular/core';
    import { ComponentCacheService } from '../services/component-cache.service';
    import { ResponseQueryByCriteria } from '../shared/dto/responseQueryByCriteria';
    import { GenericListComponent } from '../shared/GenericListCoumponent';
  import { DeviceAziendaleService } from '../services/device-aziendali/device.service';
  import { DeviceDTO } from '../shared/dto/device-aziendali/device';
  import { CollaboratoreDTO } from '../shared/dto/domain/collaboratore';
  import { DeviceTypeDTO } from '../shared/dto/device-aziendali/deviceType';
  import { CollaboratoreService } from '../services/domain/collaboratore.service';
  import { DeviceTypeService } from '../services/device-aziendali/device-type.service';
    
    @Component({
      selector: 'app-location',
      templateUrl: './devices.component.html',
      styleUrls: ['./devices.component.scss']
    })

    export class DeviceComponent extends GenericListComponent implements OnInit, OnDestroy {

      public listaTipi: DeviceTypeDTO[] = [];
      public listaCollaboratori: CollaboratoreDTO[] = [];

      // Mappa per i Tipi: Chiave (ID) -> Valore (Descrizione)
      public recordTipi: Record<number, string> = {};
      // Mappa per i Collaboratori: Chiave (ID) -> Valore (Nome)
      public recordCollaboratori: Record<number, string> = {};
    
      constructor(
        private deviceService: DeviceAziendaleService,
        private deviceTypeService: DeviceTypeService,
        private collaboratoreService: CollaboratoreService,
        componentCacheService: ComponentCacheService,
        navigatorService: NavigatorService,
        dateAdapter: DateAdapter<Date>,
        router: Router,
        snackBar: MatSnackBar,
        timestampFormatPipe: TimestampFormatPipe
      ) {
        super(
          navigatorService,
          componentCacheService,
          dateAdapter,
          router,
          snackBar,
          timestampFormatPipe);
        this.displayedColumns = ['id', 'codiceCespite', 'mac', 'serie', 'fattura', 'dataConsegna', 'dataRiconsegna', 'formattato', 'tipoId', 'collaboratore', 'detail'];
        this.parameters = {
          dataSource: [],
          showList: false,
          filter: null,
          sortField: null,
          sortDirection: null,
          pageNumber: 0,
          pageSize: 50,
          length: 0
        } 
      }
    
      list() {
        this.deviceService.deviceList(
          this.parameters.pageNumber,
          this.parameters.pageSize,
          this.parameters.sortDirection,
          this.parameters.sortField,
          this.parameters.filter).subscribe(
            (res: ResponseQueryByCriteria<DeviceDTO>) => {
              console.log("response : " + res);
              this.parameters.dataSource = res.content;
              this.parameters.pageNumber = res.pageNumber;
              this.parameters.length = res.totalElements;
              this.parameters.showList = true;
            }
          )
      }
    
      ngOnInit() {
        super.ngOnInit();
        this.loadReferences();
      }

      loadReferences(): void {
        
        this.deviceTypeService.typeList(0, 9999, 'ASC', 'descrizione', '').subscribe(
          (res) => {
            if (res && res.content) {
              this.listaTipi = res.content;
              this.popolaRecordTipi();
            }
          }
        );
        
        // Carica la lista di tutti i COLLABORATORI
        this.collaboratoreService.collaboratoreList(0, 9999, 'ASC', 'userName', '').subscribe(
          (res) => {
            if (res && res.content) {
              this.listaCollaboratori = res.content;
              this.popolaRecordCollaboratori();
            }
          }
        );
      }

      /** Restituisce la descrizione leggendo direttamente dalla mappa */
    public getDescrizioneTipo(id: number): string {
      // Accediamo direttamente all'ID. Se non esiste, restituisce 'N/A'
      return this.recordTipi[id] || 'N/A';
    }

    /** Restituisce il nome leggendo direttamente dalla mappa */
    public getNomeCollaboratore(id: number): string {
      return this.recordCollaboratori[id] || 'N/A';
    }


    private popolaRecordTipi(): void {
      this.recordTipi = {}; // Pulisce la vecchia mappa per sicurezza
      this.listaTipi.forEach(tipo => {
        // Associa ID -> Descrizione
        this.recordTipi[tipo.id] = tipo.descrizione;
      });
    }

    private popolaRecordCollaboratori(): void {
      this.recordCollaboratori = {}; // Pulisce la vecchia mappa per sicurezza
      this.listaCollaboratori.forEach(coll => {
        // Associa ID -> UserName
        this.recordCollaboratori[coll.id] = coll.userName;
      });
    }

      ngOnDestroy(): void {
        super.ngOnDestroy();
      }
    }
    